import { resCode } from '@/constants/resCodeConst';
import interceptors from './interceptors/index';
import md5 from 'crypto-js/md5';
import { formateTimestamp } from '@/utils/basicTool';

export class WxRequest {
  private config;
  private interceptor = {
    async request() {
      for (const fn of interceptors.requestInterceptor) {
        await Promise.resolve(fn.call(this));
      }
    },
    async response() {
      for (const fn of interceptors.responseInterceptor) {
        await Promise.resolve(fn.call(this));
      }
    },
  };
  public constructor(opts) {
    this.config = opts;
  }
  public post(config) {
    return this._request({ ...config, method: 'POST' });
  }
  public get(config) {
    return this._request({ ...config, method: 'GET' });
  }

  private async _request(config): Promise<any> {
    console.log('config: ', config);
    if (!config.noBeforeHook) {
      await this.interceptor.request();
    }
    return new Promise((resolve, reject) => {
      if (!this.config.noLoading && !config.noLoading) {
        // wx.showLoading({
        //   title: '',
        //   mask: config.loadingMask || this.config.loadingMask || true, // 默认强制防止点击穿透
        // });
      }
      const _self = this;
      const Appid = config.data.appId;
      const Timestamp = new Date().getTime();
      const minTimestamp = formateTimestamp(Timestamp);
      const Authorization = md5(String(Appid) + String(config.data.keyCode) + String(minTimestamp)).toString();
      // const Authorization = md5('wx8b4e233fcae585e72ze7sxj4lm1bf51s1719211080').toString();

      console.log('MD5 data: ', Authorization);
      wx.request({
        url: this.config.baseUrl,
        data: config.data,
        header: {
          ...this.config.header,
          ...config.header,
          Appid,
          Timestamp,
          Authorization,
        },
        method: config.method,
        timeout: config.timeout || this.config.timeout || 60000,
        dataType: config.dataType || 'json',
        responseType: config.responseType || 'text',
        sslVerify: config.sslVerify || this.config.sslVerify || true,
        withCredentials: config.withCredentials || this.config.withCredentials || false,
        success(res) {
          const data = res.data;
          if (resCode.successCode.includes(data.code)) {
            resolve(data);
          } else {
            reject(data);
          }
        },
        fail(err) {
          reject(err);
        },
        complete(res) {
          if (!_self.config.noLoading && !config.noLoading) {
            // wx.hideLoading();
          }
          // console.log('req complete: ', res);
          console.group('-- 接口请求 --');
          // console.log('bury', baseTools.buryingAction({}));
          console.log('%c requestUrl : ', 'background-color: green;', config.url);
          console.log('%c requestData : ', 'background-color: green;', config.data);
          console.log('%c requestResult : ', 'background-color: green;', res);
          console.groupEnd();
        },
      });
    });
  }
}

export default WxRequest;
